export default {
  title: 'Want to learn more about your energy?',
  paragraph:
    "Energy tracker can show you where the energy in your home is going. And what it's costing you.",
  buttonTextFirstTime: 'Understand your energy',
  buttonTextReturning: 'Understand your energy',
};
